import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function TermsPage() {
  useMetaTags({
    title: 'Terms & Conditions | FindOnlineDegrees',
    description: 'Terms and conditions for using FindOnlineDegrees.org'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-1536">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-1537">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1538">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-1539">
            Terms & Conditions
          </h1>
          <p className="text-gray-300 text-sm" data-id="element-1540">Last updated: May 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1541">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-1542">
          {/* Agreement to Terms */}
          <div data-id="element-1543">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1544">
              AGREEMENT TO TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1545">
              <p data-id="element-1546">
                These Terms of Use constitute a legally binding agreement
                between you and FindOnlineDegrees.org concerning your access to
                and use of the website. By accessing the site, you confirm that
                you have read, understood, and agree to be bound by these Terms
                of Use.{' '}
                <strong data-id="element-1547">
                  IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, YOU ARE
                  PROHIBITED FROM USING THE SITE AND MUST DISCONTINUE USE
                  IMMEDIATELY.
                </strong>
              </p>
              <p data-id="element-1548">
                We reserve the right to make changes or modifications to these
                Terms of Use at any time and for any reason. We will alert you
                to any changes by updating the "Last updated" date above. Your
                continued use of the site after revised terms are posted
                constitutes acceptance of the changes.
              </p>
              <p data-id="element-1549">
                The site is intended for users who are at least{' '}
                <strong data-id="element-1550">18 years</strong> old. Persons under 18 are not
                permitted to use or register for the site.
              </p>
            </div>
          </div>

          {/* Intellectual Property Rights */}
          <div data-id="element-1551">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1552">
              INTELLECTUAL PROPERTY RIGHTS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1553">
              <p data-id="element-1554">
                Unless otherwise indicated, the site is our proprietary
                property, and all source code, databases, functionality,
                software, website designs, audio, video, text, photographs, and
                graphics on the site are owned or controlled by us or licensed
                to us, and are protected by copyright and trademark laws.
              </p>
              <p data-id="element-1555">
                The content is provided <strong data-id="element-1556">"AS IS"</strong> for your
                information and personal use only. Except as expressly provided
                in these Terms of Use, no part of the site or content may be
                copied, reproduced, aggregated, republished, uploaded, posted,
                publicly displayed, encoded, translated, transmitted,
                distributed, sold, licensed, or otherwise exploited for any
                commercial purpose without our express prior written permission.
              </p>
              <p data-id="element-1557">
                You are granted a limited license to access and use the site and
                to download or print a copy of any portion of the content to
                which you have properly gained access solely for your{' '}
                <strong data-id="element-1558">personal, non-commercial use</strong>.
              </p>
            </div>
          </div>

          {/* User Representations */}
          <div data-id="element-1559">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1560">
              USER REPRESENTATIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1561">
              <p data-id="element-1562">By using the site, you represent and warrant that:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1563">
                <li data-id="element-1564">
                  All registration information you submit will be true,
                  accurate, current, and complete
                </li>
                <li data-id="element-1565">
                  You will maintain the accuracy of such information and
                  promptly update it as necessary
                </li>
                <li data-id="element-1566">
                  You have the legal capacity and agree to comply with these
                  Terms of Use
                </li>
                <li data-id="element-1567">
                  You are not a minor in the jurisdiction in which you reside
                </li>
                <li data-id="element-1568">
                  You will not access the site through automated or non-human
                  means
                </li>
                <li data-id="element-1569">
                  You will not use the site for any illegal or unauthorized
                  purpose
                </li>
                <li data-id="element-1570">
                  Your use of the site will not violate any applicable law or
                  regulation
                </li>
              </ul>
            </div>
          </div>

          {/* Prohibited Activities */}
          <div data-id="element-1571">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1572">
              PROHIBITED ACTIVITIES
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1573">
              <p data-id="element-1574">
                You may not access or use the site for any purpose other than
                that for which we make the site available. The site may not be
                used in connection with any commercial endeavors except those
                that are specifically endorsed or approved by us.
              </p>
              <p data-id="element-1575">As a user of the site, you agree not to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1576">
                <li data-id="element-1577">
                  Systematically retrieve data or other content from the site to
                  create a collection, compilation, database, or directory
                </li>
                <li data-id="element-1578">
                  Make any unauthorized use of the site, including collecting
                  usernames and/or email addresses by electronic or other means
                </li>
                <li data-id="element-1579">
                  Use the site to advertise or offer to sell goods and services
                </li>
                <li data-id="element-1580">
                  Circumvent, disable, or otherwise interfere with
                  security-related features of the site
                </li>
                <li data-id="element-1581">
                  Engage in unauthorized framing of or linking to the site
                </li>
                <li data-id="element-1582">Trick, defraud, or mislead us and other users</li>
                <li data-id="element-1583">
                  Interfere with, disrupt, or create an undue burden on the site
                  or the networks or services connected to the site
                </li>
                <li data-id="element-1584">Attempt to impersonate another user or person</li>
                <li data-id="element-1585">
                  Use any information obtained from the site to harass, abuse,
                  or harm another person
                </li>
                <li data-id="element-1586">
                  Use the site in a manner inconsistent with any applicable laws
                  or regulations
                </li>
              </ul>
            </div>
          </div>

          {/* User Generated Contributions */}
          <div data-id="element-1587">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1588">
              USER GENERATED CONTRIBUTIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1589">
              <p data-id="element-1590">
                The site may invite you to chat, contribute to, or participate
                in blogs, message boards, online forums, and other
                functionality. Any content you transmit to the site will be
                treated as non-confidential and non-proprietary.
              </p>
              <p data-id="element-1591">
                By posting content to the site, you grant us an unrestricted,
                unlimited, irrevocable, perpetual, non-exclusive, transferable,
                royalty-free, fully-paid, worldwide right to use, copy,
                reproduce, distribute, and display such content.
              </p>
            </div>
          </div>

          {/* Submissions */}
          <div data-id="element-1592">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1593">
              SUBMISSIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1594">
              <p data-id="element-1595">
                You acknowledge and agree that any questions, comments,
                suggestions, ideas, feedback, or other information regarding the
                site provided by you to us are non-confidential and shall become
                our sole property. We shall own exclusive rights, including all
                intellectual property rights, and shall be entitled to the
                unrestricted use and dissemination of these submissions for any
                lawful purpose, commercial or otherwise, without acknowledgment
                or compensation to you.
              </p>
            </div>
          </div>

          {/* Site Management */}
          <div data-id="element-1596">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1597">
              SITE MANAGEMENT
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1598">
              <p data-id="element-1599">We reserve the right, but not the obligation, to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1600">
                <li data-id="element-1601">Monitor the site for violations of these Terms of Use</li>
                <li data-id="element-1602">
                  Take appropriate legal action against anyone who violates the
                  law or these Terms of Use
                </li>
                <li data-id="element-1603">
                  Refuse, restrict access to, limit availability of, or disable
                  any of your contributions
                </li>
                <li data-id="element-1604">
                  Remove from the site or otherwise disable all files and
                  content that are excessive in size or burdensome to our
                  systems
                </li>
                <li data-id="element-1605">
                  Manage the site in a manner designed to protect our rights and
                  property and to facilitate the proper functioning of the site
                </li>
              </ul>
            </div>
          </div>

          {/* Privacy Policy */}
          <div data-id="element-1606">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1607">
              PRIVACY POLICY
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1608">
              <p data-id="element-1609">
                We care about data privacy and security. Please review our
                Privacy Policy. By using the site, you agree to be bound by our
                Privacy Policy, which is incorporated into these Terms of Use.
              </p>
            </div>
          </div>

          {/* SMS Communications Terms */}
          <div data-id="element-1610">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1611">
              SMS COMMUNICATIONS TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1612">
              <p data-id="element-1613">
                By providing your mobile phone number and submitting a form on
                our site, you agree to the following terms governing SMS/text
                message communications:
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1614">Program Description</h3>
              <p data-id="element-1615">
                FindOnlineDegrees.org may send you autodialed and/or
                pre-recorded marketing text messages (SMS/MMS) regarding
                educational programs, follow-up inquiries, and promotional
                offers from us and our educational partners.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1616">Consent</h3>
              <p data-id="element-1617">
                By submitting your information, you expressly consent to receive
                such messages at the mobile number provided. Consent is not a
                condition of any purchase or service. Your consent is governed
                by our Privacy Policy, which is incorporated herein by
                reference.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1618">Message Frequency</h3>
              <p data-id="element-1619">
                Message frequency varies. You may receive multiple messages per
                inquiry depending on your interactions and program interests.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1620">Costs</h3>
              <p data-id="element-1621">
                Message and data rates may apply. Contact your wireless carrier
                for details about your plan.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1622">Opt-Out</h3>
              <p data-id="element-1623">
                You may opt out of SMS communications at any time by replying
                STOP to any message received. After opting out, you will receive
                a single confirmation message and no further SMS marketing
                messages will be sent unless you provide new consent.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1624">Assistance</h3>
              <p data-id="element-1625">
                For help, reply HELP to any message or contact us through the
                information provided on our website.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1626">
                No Warranty for Delivery
              </h3>
              <p data-id="element-1627">
                We do not guarantee that SMS messages will be delivered.
                Delivery is subject to effective transmission and your carrier's
                coverage and policies. We are not liable for delays or failures
                in SMS delivery.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1628">Third-Party Carriers</h3>
              <p data-id="element-1629">
                You acknowledge that SMS transmission involves third-party
                carriers over whom we have no control. Standard carrier terms
                and conditions apply.
              </p>
            </div>
          </div>

          {/* Email Communications Terms */}
          <div data-id="element-1630">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1631">
              EMAIL COMMUNICATIONS TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1632">
              <h3 className="font-bold text-lg" data-id="element-1633">Program Description</h3>
              <p data-id="element-1634">
                FindOnlineDegrees.org may send you marketing and promotional
                emails regarding educational programs, follow-up inquiries, and
                offers from us and our educational partners. Marketing emails
                are sent from contact@findonlinedegrees.org on behalf of Media
                Matchers LLC.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1635">Consent</h3>
              <p data-id="element-1636">
                By submitting your information on our site, you expressly
                consent to receive such emails at the address provided. Consent
                is not a condition of any purchase or service.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1637">Opt-Out</h3>
              <p data-id="element-1638">
                You may opt out of marketing emails at any time by clicking the
                unsubscribe link included in every marketing email. Opt-out
                requests will be honored within 10 business days. You may also
                opt out by contacting us at the address below.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1639">CAN-SPAM Compliance</h3>
              <p data-id="element-1640">
                All commercial emails we send will accurately identify the
                sender, include our physical mailing address, and include a
                working unsubscribe mechanism.
              </p>
            </div>
          </div>

          {/* Term and Termination */}
          <div data-id="element-1641">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1642">
              TERM AND TERMINATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1643">
              <p data-id="element-1644">
                These Terms of Use shall remain in full force and effect while
                you use the site. We reserve the right to deny access to the
                site to anyone for any reason at any time without notice.
              </p>
              <p data-id="element-1645">
                If we terminate or suspend your access for any reason, you are
                prohibited from registering and creating a new account under
                your name or a borrowed name. We reserve the right to take
                appropriate legal action, including civil, criminal, and
                injunctive redress.
              </p>
            </div>
          </div>

          {/* Disclaimer */}
          <div data-id="element-1646">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1647">
              DISCLAIMER
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1648">
              <p data-id="element-1649">
                THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
                AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR
                SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM
                ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE
                AND YOUR USE THEREOF.
              </p>
              <p data-id="element-1650">
                WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
                COMPLETENESS OF THE SITE'S CONTENT OR THE CONTENT OF ANY
                WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR
                RESPONSIBILITY FOR ANY ERRORS, MISTAKES, OR INACCURACIES OF
                CONTENT AND MATERIALS.
              </p>
            </div>
          </div>

          {/* Limitations of Liability */}
          <div data-id="element-1651">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1652">
              LIMITATIONS OF LIABILITY
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1653">
              <p data-id="element-1654">
                IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
                LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
                CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
                DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
                OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE.
              </p>
            </div>
          </div>

          {/* Indemnification */}
          <div data-id="element-1655">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1656">
              INDEMNIFICATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1657">
              <p data-id="element-1658">
                You agree to defend, indemnify, and hold us harmless, including
                our subsidiaries, affiliates, and all of our respective
                officers, agents, partners, and employees, from and against any
                loss, damage, liability, claim, or demand, including reasonable
                attorneys' fees and expenses, made by any third party due to or
                arising out of your use of the site or breach of these Terms of
                Use.
              </p>
            </div>
          </div>

          {/* Governing Law */}
          <div data-id="element-1659">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1660">
              GOVERNING LAW
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1661">
              <p data-id="element-1662">
                These Terms of Use and your use of the site are governed by and
                construed in accordance with the laws of the State of
                California, without regard to its conflict of law principles.
                Except for disputes subject to binding arbitration under the
                Dispute Resolution / Arbitration section below, you agree that
                any dispute arising out of or relating to these Terms shall be
                resolved exclusively in the state or federal courts located in
                Los Angeles County, California.
              </p>
            </div>
          </div>

          {/* Dispute Resolution / Arbitration */}
          <div data-id="element-1663">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1664">
              DISPUTE RESOLUTION / ARBITRATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1665">
              <p data-id="element-1666">
                Any dispute, claim, or controversy arising out of or relating to
                these Terms or your use of the site, including any claims under
                the Telephone Consumer Protection Act (TCPA), shall be resolved
                by binding individual arbitration under the rules of the
                American Arbitration Association. You waive any right to bring
                or participate in a class action lawsuit or class-wide
                arbitration. This arbitration agreement does not apply to claims
                that may be brought in small claims court.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-1667">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1668">
              CONTACT US
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1669">
              <p data-id="element-1670">
                If you have any questions or concerns about these Terms &
                Conditions, please contact us at:
              </p>
              <p className="font-semibold" data-id="element-1671">Media Matchers LLC</p>
              <p data-id="element-1672">
                1865 Chestnut Street
                <br data-id="element-1673" />
                San Francisco, CA 94123
              </p>
              <p data-id="element-1674">
                Email:{' '}
                <a href="mailto:contact@findonlinedegrees.org" className="text-[#3b82f6] underline hover:text-blue-800" data-id="element-1675">
                  contact@findonlinedegrees.org
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}